import { defineStore } from "pinia";
import DataSource from "devextreme/data/data_source";
import { ref } from "vue";
import { usePegawaiListModel } from "@/stores/models/pegawai-list-model";

export const usePegawaiListStore = defineStore("pegawaiListStore", () => {
  const isLoading = ref(false);
  const dataSourcePegawaiList = ref(
    new DataSource({
      requireTotalCount: true,
      store: usePegawaiListModel().pegawaiListCustomStore,
      filter: null,
    }),
  );

  const dataSourcePegawaiPensiunList = ref(
    new DataSource({
      requireTotalCount: true,
      store: usePegawaiListModel().pegawaiListCustomStore,
      filter: [["status_aktifs_nama", "=", "Pensiun"]], // Updated value
    }),
  );

  // const dataSourcePegawaiList = (additionalParams = null) => {
  //     console.log('masuk dataSourcePegawaiList', additionalParams)
  //     return new DataSource({
  //       requireTotalCount: true,
  //       load: (loadOptions) => {
  //         // Handle load options and additionalParams separately
  //         return usePegawaiListModel().pegawaiListCustomStore.load([loadOptions, additionalParams]);
  //       }
  //     });
  // };

  const getData = async (filter) => {
    usePegawaiListModel().setFilter(filter);
    usePegawaiListModel().setTake("all");
    await dataSourcePegawaiList.value.reload();

    //  const totalBiaya = _.sumBy(dataSourceDiklatList.value.items(), 'biaya');
    let result = {
      data: dataSourcePegawaiList.value._items,
      totalCount: dataSourcePegawaiList.value._items.length,
      // summary: [totalBiaya]
    };
    //  return {
    //     data: dataSourcePegawaiList.value._items,
    //     totalCount: dataSourcePegawaiList.value._items.length,
    //     // summary: [totalBiaya]
    // };
    usePegawaiListModel().setFilter(null);
    return result;

    //  return dataSourceDiklatList.value._items;
  };

  const dataSourcePegawaiListCoba = (
    additionalParamsFilter = null,
    additionalParamsSort = null,
  ) => {
    return usePegawaiListModel().pegawaiListArray(
      additionalParamsFilter,
      additionalParamsSort,
    );
  };

  const dataSourcePegawaiListUpdate = (key = null, values = null) => {
    return usePegawaiListModel().pegawaiListUpdate(key, values);
  };

  const dataSourcePegawaiListDelete = (key = null) => {
    return usePegawaiListModel().pegawaiListDelete(key);
  };

  const state = ref(true);
  const refresh = () => {
    dataSourcePegawaiList.value.reload();
  };

  const initialized = () => {
    usePegawaiListModel().setFilter(null);
    dataSourcePegawaiList.value.reload();
  };

  return {
    dataSourcePegawaiList,
    dataSourcePegawaiPensiunList,
    dataSourcePegawaiListCoba,
    dataSourcePegawaiListUpdate,
    dataSourcePegawaiListDelete,
    isLoading,
    refresh,
    initialized,
    state,
    getData,
  };
});
